import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { SubtitleCard } from 'core/components/SubtitleCards/SubtitleCard';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { pricingTypeLabelKey } from 'pricing/constants';
import { PricingType } from 'pricing/enums';
import { PricingHelper } from 'pricing/helpers';
import { Level } from 'theme/enums';

interface IProps {
  groupName: string;
  listPrice?: number | null;
  uom?: string;
  pricingType?: PricingType;
  vendorName?: string;
  highlighted?: boolean;
  buttons?: ReactElement[];
}

const baseCardSx = { width: 260, flex: 'none' };
const highlightedSx = {
  ...baseCardSx,
  backgroundColor: 'primary.softBg',
  border: '1px solid',
  borderColor: 'primary.softBg',
};

export const VendorPriceCard = ({
  groupName,
  listPrice,
  uom,
  pricingType,
  vendorName,
  highlighted,
  buttons,
}: IProps) => {
  const { t } = useTranslation();

  const listPriceDisplay =
    listPrice != null ? PricingHelper.formatPricingPerUom(listPrice, uom) : DEFAULT_PLACEHOLDER;

  const pricingLabelKey = pricingType ? pricingTypeLabelKey[pricingType] ?? null : null;
  const pricingTypeLabel = pricingLabelKey ? t(pricingLabelKey) : null;

  return (
    <SubtitleCard
      label={groupName}
      subtitle={vendorName}
      value={listPriceDisplay}
      extra={pricingTypeLabel}
      buttons={buttons}
      options={{
        cardSx: highlighted ? highlightedSx : baseCardSx,
        contentSx: { justifyContent: 'space-between' },
        labelProps: { level: Level.TITLE_MD, color: null },
      }}
    />
  );
};
